module.exports = __webpack_public_path__ + "static/media/login_gov_code.780e2faa.png";